import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgRemove = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 22,
	height: 22,
	viewBox: "0 0 22 22",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M5.665 10.263 C 5.388 10.391,5.170 10.716,5.170 11.000 C 5.170 11.284,5.388 11.609,5.665 11.737 C 5.806 11.802,6.035 11.805,11.414 11.806 C 17.554 11.807,17.152 11.821,17.394 11.594 C 17.716 11.292,17.716 10.708,17.394 10.406 C 17.152 10.179,17.554 10.193,11.414 10.194 C 6.035 10.195,5.806 10.198,5.665 10.263 ",
		stroke: "none",
		fillRule: "evenodd",
		fill: "currentColor"
	})
});
export default SvgRemove;
